import { createAction, props } from '@ngrx/store';

import {
    IListGames,
    InfoConnetion,
    IRespListGames,
    IResptGetStatusLifes,
    IResptRating,
    IResptRatingByGame,
    IResptSaveGoing,
    ISaveGoingSend,
    IUserInfoGames,
} from '../../shared/models/Games.model';

/**
 * Obtiene la lista de juegos
 */
export const getListGames = createAction(
    '[GetListGames] Get List Games'
);

export const successListGames = createAction(
    '[GetListGames] Get List Games Success',
    props<IRespListGames>()
);

export const errorListGames = createAction(
    '[GetListGames] Get List Games Error',
    props<{ payload: Error }>()
);

/**
 * Obtiene la info del usuario
 */
export const getUserInfoGames = createAction(
    '[getUserInfoGames] Get User Info Games',
);

export const successUserInfoGames = createAction(
    '[getUserInfoGames] User Info Games Success',
    props<IUserInfoGames>()
);

export const errorUserInfoGames = createAction(
    '[getUserInfoGames] User Info Games Error',
    props<{ payload: Error }>()
);

/**
 * Obtiene la info del leaderboard general
 */
export const getRating = createAction(
    '[getRating] Get Info Rating Games',
);

export const successRating = createAction(
    '[getRating] Info Rating Games Success',
    props<IResptRating>()
);

export const errorRating = createAction(
    '[getRating] Info Rating Games Error',
    props<{ payload: Error }>()
);

/**
 * Obtiene la info del leaderboard por juego
 */
export const getRatingByGame = createAction(
    '[getRatingByGame] Get Info Rating Games',
    props<{ PorPuntaje: number, ID_Juego: number; }>()
);

export const successRatingByGame = createAction(
    '[getRatingByGame] Info Rating Games Success',
    props<IResptRatingByGame>()
);

export const errorRatingByGame = createAction(
    '[getRatingByGame] Info Rating Games Error',
    props<{ payload: Error }>()
);
export const ClearRatingByGame = createAction(
    '[ClearRatingByGame] Clear Rating By Game Select'
);

export const selectGame = createAction(
    '[Selectgame] Set Game Select Click',
    props<IListGames>()
);
export const selectGameReset = createAction(
    '[Selectgame] Clear Game Select'
);

/**
 * Guarda la informacion de la partida
 */
export const saveGoing = createAction(
    '[saveGoing] Save departure Game',
    props<ISaveGoingSend>()
);

export const successSaveGoing = createAction(
    '[saveGoing] Save departure Game Success',
    props<IResptSaveGoing>()
);

export const errorSaveGoing = createAction(
    '[saveGoing] Save departure Game Error',
    props<{ payload: Error }>()
);

/**
 * Redime las vidas de la partida
 */
export const startGame = createAction(
    '[StartGame] Save init game and live use Game',
    props<{ ID_Juego: number; }>()
);

export const successStartGame = createAction(
    '[StartGame] Save init game and live use Game Success',
    props<IResptSaveGoing>()
);

export const errorStartGame = createAction(
    '[StartGame] Save init game and live use Game Error',
    props<{ payload: Error }>()
);

/**
 * Consulta si es modal de aviso de seccion o modal de recompensa diaria
 */
export const statusLifesModal = createAction(
    '[StatusLifesModal] Check section notice or daily reward'
);

export const successStatusLifesModal = createAction(
    '[StatusLifesModal] Check section notice or daily reward Success',
    props<IResptGetStatusLifes>()
);

export const errorStatusLifesModal = createAction(
    '[StatusLifesModal] Check section notice or daily reward Error',
    props<{ payload: Error }>()
);

/**
 * Envia el evento si dio true a las modales de aviso o vida diaria
 */
export const sendStatusLifesModal = createAction(
    '[SendStatusLifesModal] Send section notice or daily reward',
    props<{ status: 0 | 1 | 2 }>()
);

export const successSendStatusLifesModal = createAction(
    '[SendStatusLifesModal] Send section notice or daily reward Success',
    props<IResptSaveGoing>()
);

export const errorSendStatusLifesModal = createAction(
    '[SendStatusLifesModal] Send section notice or daily reward Error',
    props<{ payload: Error }>()
);

/**
 * Envia el evento de la info de dispositivo por conexion del app
 */
export const sendConnection = createAction(
    '[sendConnection] Send info device connection',
    props<InfoConnetion>()
);

export const successSendConnection = createAction(
    '[sendConnection] Send info device connection Success',
    props<IResptSaveGoing>()
);

export const errorSendConnection = createAction(
    '[sendConnection] Send info device connection Error',
    props<{ payload: Error }>()
);

/**
 * Vidas extras popup
 */
export const extrasLives = createAction(
    '[ExtrasLives] Send info device connection',
    props<{ VidasGanadas: number; }>()
);
